module.exports = "/_next/static/images/1c65ae2043b314263a297cb8b1ca677c-icon-app-new.svg";